import { filter, propEq, propOr } from 'ramda';

const useNiveauxGarantiesTarifsPrevTnsInvaliditeForm = ({ form, guarantees, getMiddleText }) => {
  const garInval = form.watch('guarantees.OPTION_INVAL.selected');
  const garInvalOptionDep = form.watch('guarantees.OPTION_INVAL_DEP.selected');

  const { OPTION_INVAL, INVAL_MAD, OPTION_INVAL_DEP, INVAL_DEP_CAP } = guarantees;

  const invaliditeCotisation = [
    {
      displayed: garInval,
      label: getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INVAL_LABEL'),
      monthlyAmount: propOr(0.0, 'monthlyPrice', OPTION_INVAL),
      yearlyAmount: propOr(0.0, 'annualPrice', OPTION_INVAL)
    },
    {
      displayed: garInvalOptionDep,
      label: getMiddleText('NIVEAUXGARANTIESETTARIFS_GAR_INVAL_OPTION_DEPENDANCE_LABEL'),
      monthlyAmount: propOr(0.0, 'monthlyPrice', INVAL_DEP_CAP),
      yearlyAmount: propOr(0.0, 'annualPrice', INVAL_DEP_CAP)
    }
  ];

  return {
    garInval,
    garInvalOptionDep,
    OPTION_INVAL,
    INVAL_MAD,
    OPTION_INVAL_DEP,
    invaliditeCotisation: filter(propEq('displayed', true), invaliditeCotisation)
  };
};

export default useNiveauxGarantiesTarifsPrevTnsInvaliditeForm;
